import CityPageTemplate from "../city-template/CityPageTemplate";
import { lakewoodCoConfig } from "./data";

export default function LakewoodCoPage() {
  return <CityPageTemplate config={lakewoodCoConfig} />;
}